import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported 1:1 from the prototype `.stat` (compact stat strip tile).
export const styles = {
  stat: {
    kmVPX3: "xdgoe7y",
    kWkggS: "x13uruat",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kaIpWk: "x7tdnnd",
    $$css: true
  },
  toneDanger: {
    kVAM5u: "x1vgqim1",
    kWkggS: "x8qqj1s",
    kMwMTN: "x2wi9gy",
    $$css: true
  },
  toneWarning: {
    kVAM5u: "xrg9x96",
    kWkggS: "x1qf8r77",
    kMwMTN: "x155pc8g",
    $$css: true
  },
  action: {
    k1xSpc: "x1lliihq",
    k9WMMc: "xdpxx8g",
    kMv6JI: "xdv2sak",
    kMwMTN: "x1oezkus",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1oqrrjg x9kvfbb",
    kI3sdo: "x1a2a7pz xx4dj4q",
    k3aq6I: "x14ow2ja xnotfpo",
    $$css: true
  },
  actionHover: {
    kGzVvX: "x5lqt2c",
    kaVNsj: "x17y7a7r",
    $$css: true
  },
  active: {
    kVAM5u: "xa126vr",
    kGVxlE: "xx0s5fa",
    $$css: true
  },
  arrow: {
    koQZXg: "x8x9d4c",
    kGuDYH: "x34ze3o",
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  value: {
    kMv6JI: "xpc6l4x",
    kGuDYH: "x19b9xl8",
    k63SB2: "xomqrzn",
    kLWn49: "xtqwzw6",
    kfSwDN: "x1hx0egp",
    $$css: true
  },
  valueSkeleton: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kAzted: "xz4f4ph",
    $$css: true
  },
  label: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1fwedmp",
    keoZOQ: "x1mz4vpd",
    kGuDYH: "x2pyw9z",
    kMwMTN: "xdxw5r1",
    $$css: true
  }
};